import React from "react";

import Button from "@mui/material/Button";
import {FormattedMessage} from "react-intl";

const GroheCartStickyFooter = (props) => {

  const {stickyFooterButtons} = props;

  return (
    <div className="gc-sticky">
      {stickyFooterButtons.map(button => (
        <Button className={"look-button look-button--no-radius look-button--no-padding gc-sticky__button " + button.classes}
                variant="outlined"
                disabled={button.disabled || false}
                key={button.translate}
                onClick={button.onClick}>
          <FormattedMessage id={button.translate}/>
        </Button>
      ))}
    </div>
  )
};

export default GroheCartStickyFooter
